import { ArrowUpRightIcon, Pencil01Icon, Trash01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIActionDropdown, UITag, renderIcon } from '@gohighlevel/ghl-ui';
import { h } from 'vue';
import { useI18n } from "vue-i18n";
import { renderDateTime } from '../common/table';
import Amount from '../common/table/Amount.vue';
import PaymentLinkName from './PaymentLinkName.vue';
import PaymentLinkUrl from './PaymentLinkUrl.vue';
const getDropdownActionOptions = (row) => {
    const { t } = useI18n();
    const dataToReturn = [];
    dataToReturn.push({
        label: t('dashboard.edit'),
        key: "edit",
        icon: renderIcon(Pencil01Icon)
    });
    if (row.active) {
        dataToReturn.push({
            label: t('dashboard.deactivate'),
            key: "toggleActive",
            icon: renderIcon(Trash01Icon)
        });
    }
    else {
        dataToReturn.push({
            label: t('dashboard.activate'),
            key: "toggleActive",
            icon: renderIcon(ArrowUpRightIcon)
        });
    }
    return dataToReturn;
};
const onDropDownActionChange = async (action, item, emitter) => {
    if (action == 'edit') {
        return emitter.emit("redirect-editor", item);
    }
    else if (action == 'toggleActive') {
        return emitter.emit("toggle-link-status", item);
    }
};
export const getColumnsHeading = (t, emitter) => {
    return [
        {
            title: t('common.name'),
            width: '15%',
            render(row) {
                return h(PaymentLinkName, {
                    item: row,
                });
            },
        },
        {
            title: t('dashboard.linkUrl'),
            key: 'name',
            width: '25%',
            render(row) {
                return h(PaymentLinkUrl, {
                    item: row,
                });
            },
        },
        {
            title: t('common.status'),
            key: 'Status',
            width: '20%',
            render(row) {
                const { type, label } = row.active
                    ? { type: 'success', label: 'active' }
                    : { type: 'warning', label: 'inactive' };
                return h(UITag, {
                    type,
                    size: 'small',
                    class: 'capitalize',
                }, { default: () => label });
            },
        },
        {
            title: t('dashboard.paymentAmount'),
            key: 'price',
            width: '20%',
            render(row) {
                const amount = row.products?.[0]?.prices?.[0]?.amount || 0;
                const currency = row.products?.[0]?.prices?.[0]?.currency;
                return h(Amount, { amount, currency, liveMode: row.liveMode });
            },
        },
        {
            title: t('common.created'),
            key: 'createdAt',
            width: '20%',
            render(row) {
                return renderDateTime(row.createdAt);
            },
        },
        {
            title: "",
            key: "actions",
            render(row) {
                return h(UIActionDropdown, {
                    options: getDropdownActionOptions(row),
                    onSelect: (val) => onDropDownActionChange(val, row, emitter),
                    id: "paymentlinks-table-dropdown",
                });
            },
        }
    ];
};
export const FilterCollapseOptions = (t) => [
    {
        label: t('dashboard.filter.status'),
        key: 'status',
        type: 'select',
    },
];
export const FilterActionOptions = (t) => [
    {
        key: 'status',
        value: 'all',
        options: [
            {
                label: t('dashboard.filter.all'),
                value: 'all',
            },
            {
                label: t('dashboard.filter.active'),
                value: 'active',
            },
            {
                label: t('dashboard.filter.inactive'),
                value: 'inactive',
            },
        ],
    },
];
